import React from 'react';
import Icon from '../../../components/AppIcon';

const ResultsHeader = ({ studentName, totalRecommendations, completionDate }) => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-xl p-6 md:p-8 lg:p-10 text-white mb-6 md:mb-8">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Sparkles" size={24} color="#FBBF24" />
            <span className="text-sm md:text-base opacity-90">Résultats de l'orientation</span>
          </div>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold mb-2">
            Vos Filières Recommandées
          </h1>
          <p className="text-sm md:text-base opacity-90">
            Bonjour {studentName}, nous avons analysé votre profil et identifié {totalRecommendations} filières qui correspondent à vos compétences et aspirations.
          </p>
        </div>
        <div className="flex flex-col gap-2 bg-white/10 backdrop-blur-sm rounded-lg p-4 min-w-[200px]">
          <div className="flex items-center gap-2">
            <Icon name="Calendar" size={20} />
            <span className="text-sm">Date d'analyse</span>
          </div>
          <p className="text-lg font-semibold">{completionDate}</p>
        </div>
      </div>
    </div>
  );
};

export default ResultsHeader;